import { Outlet } from "react-router-dom";

export const NodesOutlet = () => {
  return <Outlet />;
};
